module.exports = __webpack_public_path__ + "img/max-icons.0f75051a.svg";